<template>
  <SelectSearch
    label="Membro"
    icon="icTeam"
    :value="member"
    placeholder="Coloque o membro"
    value-label="fullName"
    :search-function="searchMember"
    @input="member = $event"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { SelectSearch } from '@/components/shared/atoms'

export default {
  components: { SelectSearch },
  emits: ['changeMember'],
  data() {
    return {
      member: undefined
    }
  },
  computed: {
    ...mapGetters('member', ['getMemberById']),
    ...mapState('pillars/profile', ['liteProfile']),
    ...mapState('pillars', ['personId'])
  },
  watch: {
    member(value) {
      this.$emit('changeMember', value)
    }
  },
  mounted() {
    this.getMember()
  },
  methods: {
    async searchMember(query, signal) {
      const { personSearchResponses: response } =
        (await this.$store.dispatch('member/searchByQuery', {
          query,
          signal
        })) || {}
      return response.map(member => {
        return member
          ? {
              fullName: `${member.firstName} ${member.lastName}`,
              ...member
            }
          : {}
      })
    },
    async getMember() {
      const storeMember = this.getMemberById({ personId: this.personId })

      if (storeMember?.firstName) {
        this.member = storeMember
      } else if (this.liteProfile?.fullName) {
        const results = await this.searchMember(this.liteProfile.fullName)
        const member = results.find(member => member.id === this.personId)
        this.member = member
      }
    }
  }
}
</script>
